import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

var _ = require('lodash');
import AsyncSelect from 'react-select/async';
const axios = require('axios').default;
import Popup from "reactjs-popup";
import SlidingPane from "react-sliding-pane";

import { ToastContainer, toast } from 'react-toastify';
import { toastSuccess, toastError } from "../../../shared/toastHelper";
import PayoutSetupModal from './PayoutSetupModal';
import PayoutBankAccountBadge from './PayoutBankAccountBadge';

import MarkdownIt from 'markdown-it';
import MdEditor from 'react-markdown-editor-lite';
import {DebounceInput} from 'react-debounce-input';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

var emoji = require('markdown-it-emoji');
var taskLists = require('markdown-it-task-lists');

const mdParser = require('markdown-it')()
  .use(require('markdown-it-mark'))
  .use(require('markdown-it-ins'))
  .use(require('markdown-it-abbr'))
  .use(require('markdown-it-deflist'))
  .use(require('markdown-it-footnote'))
  .use(require('markdown-it-sub'))
  .use(require('markdown-it-sup'))
  .use(taskLists)
  .use(emoji);

const STAGE_TYPES = [
  "Auditorium", "Bar Stage", "Black Box", "Custom", "Lounge", "Main Stage", "Outdoor Stage",
  "Rooftop", "Studio", "Theater"
];

const capacityMask = createNumberMask({
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  allowNegative: false,
  allowLeadingZeroes: false,
  integerLimit: 7
});

const modalContentStyle = {
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "350px",
  "padding": "30px 15px 20px 15px"
}

const popupContentStyle = {
  "border": "1px solid #E9EAEB",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "248px",
  "padding": "0px"
}

const deleteModalContentStyle = {
  "textAlign": "left",
  "border": "none",
  "borderRadius": "8px",
  "boxShadow": "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  "width": "500px",
  "padding": "15px"
}

export const uploadImageEmbed = (csrfToken, team, file, callback) => {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

  var params = new FormData();
  params.append("image_embed[image]", file);

  return axios.post("/teams/" + team.id + "/image_embeds", params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(({ data }) => {
      callback(data.url);
    });
};

const canSubmitVenueSuggestionForm = (venueSuggestion) => {
  return (
    venueSuggestion.name
      && venueSuggestion.address1
      && venueSuggestion.city
      && venueSuggestion.state
      && venueSuggestion.zip
  );
}

const canSubmitVenueOwnershipForm = (venueOwnership) => {
  return (
    venueOwnership
      && isValidPhoneNumber(venueOwnership.phone)
      && isValidEmail(venueOwnership.email)
  );
}

const isValidPhoneNumber = (value) => {
  var stringValue = (value || "");
  var nonDigit = /\D/ig;
  var phoneNumber = stringValue.replaceAll(nonDigit, "");

  return (
    phoneNumber.length === 0
      || phoneNumber.length === 10
  );
}

const isValidEmail = (value) => {
  return (
    !value
      || (
        value.length > 0
          && validateEmail(value)
      )
  );
}

// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const debouncedFetch = _.debounce((inputValue, callback, venueOwnerships) => {
  var omitVenueIds = venueOwnerships.filter((venueOwnership) => {
    return venueOwnership.venueable_type === "Venue";
  }).map((venueOwnership) => {
    return venueOwnership.venueable.id;
  });

  new Promise(resolve => {
    axios.get("/venues/search", {
        params: {
          name: inputValue,
          omit_ids: omitVenueIds
        }
      })
      .then(function (response) {
        var newOptions = response.data.map(function(data) {
          var cityState = [data.city, data.state].filter(item => item).join(', ');

          var capacityString = (data.capacity && data.capacity !== 0) ? ` (Cap: ${data.capacity})` : '';

          return { value: data.id, label: `${data.name} - ${cityState}${capacityString}` };
        });

        callback(newOptions);
      })
  });
}, 250);

const VenueManager = ({
  csrfToken,
  user,
  team,
  venueOwnerships,
  deleteVenueOwnership,
  createVenueOwnership,
  settingUpTeam,
  venueSuggestionFormOpen,
  manualVenueEntryClicked,
  venueSuggestion,
  venueSuggestionNameChanged,
  venueSuggestionAddressOneChanged,
  venueSuggestionAddressTwoChanged,
  venueSuggestionCityChanged,
  venueSuggestionStateChanged,
  venueSuggestionZipChanged,
  venueStateOptions,
  createVenueSuggestion,
  modalIsOpen,
  closeModal,
  cancelEditVenueOwnership,
  venueOwnershipBioChanged,
  venueOwnershipLogoElChanged,
  venueOwnershipLogoChanged,
  venueOwnershipTicketLogoElChanged,
  venueOwnershipTicketLogoChanged,
  fetchVenueOwnership,
  venueOwnershipLogoRemoved,
  venueOwnershipTicketLogoRemoved,
  updateVenueOwnership,
  venueOwnershipChanged,
  availableTimezones,
  payoutSetup,
  payoutSetupVenueOwnershipId,
  payoutSetupOpened,
  payoutSetupClosed,
  assignPayoutBankAccount
}) => {
  const [room, setRoom] = useState(null);
  const payoutSetupEnabled = !settingUpTeam && !!payoutSetup?.enabled;
  const payoutSetupVenueOwnership = payoutSetupEnabled
    ? venueOwnerships.find((vo) => vo.id === payoutSetupVenueOwnershipId)
    : null;
  const [printers, setPrinters] = useState([]);
  const printerUri = useRef(null);

  const canSubmitRoomForm = () => {
    return (
      room
        && room.name 
        && room.name.trim().length > 0
        && room.capacity
        && room.stage_type
    );
  };

  const fetchNewRoom = (venueOwnershipId) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.get("/teams/" + team.id + "/rooms/new", {
        params: {
          venue_ownership_id: venueOwnershipId
        }
      })
      .then(({ data }) => {
        var newRoom = Object.assign({}, data, {
          venue_ownership_id: venueOwnershipId,
          errors: []
        });
        setRoom(newRoom);
      })
      .catch((error) => {
        toastError("Failed to load new room form");
      });
  };

  const fetchEditRoom = (roomId) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.get("/teams/" + team.id + "/rooms/" + roomId + "/edit")
      .then(({ data }) => {
        var editRoom = Object.assign({}, data, {
          errors: [],
          isEditing: true
        });
        setRoom(editRoom);
      })
      .catch((error) => {
        toastError("Failed to load room for editing");
      });
  };

  const createRoom = (roomData) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    setRoom(Object.assign({}, roomData, {errors: []}));

    axios.post("/teams/" + team.id + "/rooms", {
        room: {
          name: roomData.name,
          capacity: roomData.capacity,
          stage_type: roomData.stage_type,
          notes: roomData.notes,
          venue_ownership_id: roomData.venue_ownership_id
        }
      })
      .then(({ data }) => {
        setRoom(null);

        const targetVenueOwnership = venueOwnerships.find(vo => vo.id === roomData.venue_ownership_id);
        if (targetVenueOwnership) {
          const updatedRooms = [...(targetVenueOwnership.rooms || []), data];
          const updatedVenueOwnership = Object.assign({}, targetVenueOwnership, { rooms: updatedRooms });
          venueOwnershipChanged(updatedVenueOwnership);
        }

        toastSuccess("Stage created successfully");
      })
      .catch((error) => {
        toastError(error.response.data.join(", "));
      });
  };

  const updateRoom = (roomData) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    setRoom(Object.assign({}, roomData, {errors: []}));

    axios.patch("/teams/" + team.id + "/rooms/" + roomData.id, {
        room: {
          name: roomData.name,
          capacity: roomData.capacity,
          stage_type: roomData.stage_type,
          notes: roomData.notes,
          venue_ownership_id: roomData.venue_ownership_id
        }
      })
      .then(({ data }) => {
        setRoom(null);

        const targetVenueOwnership = venueOwnerships.find(vo => vo.id === roomData.venue_ownership_id);
        if (targetVenueOwnership) {
          const updatedRooms = (targetVenueOwnership.rooms || []).map(existingRoom => {
            if (existingRoom.id === roomData.id) {
              return data;
            }
            return existingRoom;
          });
          const updatedVenueOwnership = Object.assign({}, targetVenueOwnership, { rooms: updatedRooms });
          venueOwnershipChanged(updatedVenueOwnership);
        }

        toastSuccess("Stage updated successfully");
      })
      .catch((error) => {
        toastError(error.response.data.join(", "));
      });
  };

  const deleteRoom = (roomData) => {
    if (!window.confirm(`Are you sure you want to remove "${roomData.name}"? This action cannot be undone.`)) {
      return;
    }

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.delete("/teams/" + team.id + "/rooms/" + roomData.id)
      .then(({ data }) => {
        setRoom(null);

        const targetVenueOwnership = venueOwnerships.find(vo => vo.id === roomData.venue_ownership_id);
        if (targetVenueOwnership) {
          const updatedRooms = (targetVenueOwnership.rooms || []).filter(existingRoom => 
            existingRoom.id !== roomData.id
          );
          const updatedVenueOwnership = Object.assign({}, targetVenueOwnership, { rooms: updatedRooms });
          venueOwnershipChanged(updatedVenueOwnership);
        }

        toastSuccess("Stage removed successfully");
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const fetchPrinters = (venueOwnership) => {
    if (!venueOwnership || !venueOwnership.id) {
      return;
    }

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    
    axios.get(`/teams/${team.id}/venue_ownerships/${venueOwnership.id}/printers`)
      .then(({ data }) => {
        setPrinters(data || []);
      })
      .catch((error) => {
        toast.error("Failed to get printers", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const addPrinter = (printerUri) => {
    const editingVenue = venueOwnerships.find(vo => vo.isEditing);
    
    if (!editingVenue) {
      toast.error("No venue is currently being edited", {
        position: toast.POSITION.TOP_CENTER,
        draggable: false,
        closeOnClick: false,
        autoClose: 5000,
        hideProgressBar: true
      });
      return;
    }

    if (!printerUri || printerUri.trim().length === 0) {
      toast.error("Please enter a printer IP address", {
        position: toast.POSITION.TOP_CENTER,
        draggable: false,
        closeOnClick: false,
        autoClose: 5000,
        hideProgressBar: true
      });
      return;
    }

    const existingIPs = printers.map(printer => 
      printer.options["device-uri"].replace("socket://", "")
    );
    if (existingIPs.includes(printerUri.trim())) {
      toastError("A printer with this IP address already exists");
      return;
    }

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.post(`/teams/${team.id}/venue_ownerships/${editingVenue.id}/printers`, {
        printer: {
          uri: printerUri.trim()
        }
      })
      .then(({ data }) => {
        // Refetch all printers to ensure we have the latest data
        const editingVenue = venueOwnerships.find(vo => vo.isEditing);
        if (editingVenue) {
          fetchPrinters(editingVenue);
        }
        toastSuccess("Printer added successfully");
      })
      .catch((error) => {
        toastError("Failed to add printer");
      });
  };

  const deletePrinter = (printer, printerIndex) => {
    const editingVenue = venueOwnerships.find(vo => vo.isEditing);

    if (!editingVenue) {
      toastError("No venue is currently being edited");
      return;
    }

    if (!window.confirm(`Are you sure you want to delete Printer ${printerIndex + 1}?`)) {
      return;
    }

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    axios.delete(`/teams/${team.id}/venue_ownerships/${editingVenue.id}/printers/${printer.name}`)
      .then(() => {
        setPrinters(prevPrinters =>
          prevPrinters.filter(p => p.name !== printer.name)
        );
        toastSuccess("Printer deleted successfully");
      })
      .catch((error) => {
        toastError("Failed to delete printer");
      });
  };

  return (
  <div className="row">
    <ToastContainer icon={false} />
    <div className="col-12">
      <div className="row">
        <div className="col-12 col-md-8">
          <AsyncSelect placeholder={"Search venues..."}
                       defaultOptions
                       value={""}
                       onChange={(option) => { createVenueOwnership(csrfToken, team, option.value, "Venue"); }}
                       loadOptions={(inputValue, callback) => debouncedFetch(inputValue, callback, venueOwnerships)} />
        </div>
        <div className="col-12">
          <p className="text-muted pt-2 mb-0">
            Can't find your venue?&nbsp;
            <strong>
              <a href="#"
                 className="text-muted"
                 onClick={
                   (e) => {
                     e.preventDefault();
                     manualVenueEntryClicked();
                   }
                 }
                 style={{"textDecoration": "underline"}}>
                Enter your details manually.*
              </a>
            </strong>
          </p>
        </div>
        {venueSuggestionFormOpen ? (
          <div className="col-12 col-md-8 pt-3">
            <div className="card venue-card no-border mb-0">
              <div className="card-body">
                <form onSubmit={
                  (e) => {
                    if(canSubmitVenueSuggestionForm(venueSuggestion)){
                      createVenueSuggestion(csrfToken, team, venueSuggestion);
                    }

                    e.preventDefault();
                  }
                }>
                  {venueSuggestion.errors.length > 0 ? (
                    <div className="form-group">
                      <div className="p-3 mb-2 bg-danger text-white rounded">
                        <ul className="mb-0">
                          {venueSuggestion.errors.map((error, key) =>
                            <li key={key}>{error}</li>
                          )}
                        </ul>
                      </div>
                    </div>
                  ) : null}
                  <div className="form-group">
                    <input type="text"
                           className="form-control no-border text-muted"
                           defaultValue={venueSuggestion.name}
                           onChange={(e) => venueSuggestionNameChanged(e.target.value)}
                           placeholder="Venue Name" />
                  </div>
                  <div className="form-row">
                    <div className="form-group col-12 col-md-6">
                      <input type="text"
                             className="form-control no-border text-muted"
                             defaultValue={venueSuggestion.address1}
                             onChange={(e) => venueSuggestionAddressOneChanged(e.target.value)}
                             placeholder="Address Line 1" />
                    </div>
                    <div className="form-group col-12 col-md-6">
                      <input type="text"
                             className="form-control no-border text-muted"
                             defaultValue={venueSuggestion.address2}
                             onChange={(e) => venueSuggestionAddressTwoChanged(e.target.value)}
                             placeholder="Address Line 2" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-12 col-md-6">
                      <input type="text"
                             className="form-control no-border text-muted"
                             defaultValue={venueSuggestion.city}
                             onChange={(e) => venueSuggestionCityChanged(e.target.value)}
                             placeholder="City" />
                    </div>
                    <div className="form-group col-12 col-md-3">
                      <select className="form-control no-border text-muted custom-select"
                             defaultValue={""}
                             onChange={(e) => venueSuggestionStateChanged(e.target.value)} >
                        <option value="">State</option>
                        {venueStateOptions.map((option, index) => (
                          <option value={option}
                                  key={index}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-12 col-md-3">
                      <input type="text"
                             className="form-control no-border text-muted"
                             defaultValue={venueSuggestion.zip}
                             onChange={(e) => venueSuggestionZipChanged(e.target.value)}
                             placeholder="Zip" />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col text-right">
                      <a href="#"
                         onClick={
                           (e) => {
                             e.preventDefault();
                             manualVenueEntryClicked();
                           }
                         }
                         className="pr-4">
                        <strong>Cancel</strong>
                      </a>
                      <button type="submit"
                              disabled={!canSubmitVenueSuggestionForm(venueSuggestion)}
                              className="btn btn-primary">
                        Add
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      {settingUpTeam ? (
        <div className="py-3" />
      ) : (
        <hr className="my-3" />
      )}
      <div className="form-row">
        {venueOwnerships.sort((a, b) => a.venueable.name.localeCompare(b.venueable.name)).map((venueOwnership, index) => (
          <div key={index} className={venueOwnership.isEditing ? "col-12" : "col-12 col-md-6 col-lg-4"}>
            <div className="card venue-card"
                  style={{
                    "border": "1px solid #E9EAEB",
                    "borderRadius": "12px"
                  }}>
              <div className='card-body' style={{"padding": "20px"}}>
                <div className='row'>
                  <div className='col-12'>
                    <p className="text-truncate"
                        title={venueOwnership.venueable.name}
                        style={{
                          "fontWeight": "600",
                          "fontSize": "16px",
                          "maxWidth": "80%"
                        }}>
                      <strong>{venueOwnership.venueable.name}</strong>
                    </p>
                    <Popup arrow={false}
                          offsetY={5}
                          position="bottom right"
                          contentStyle={popupContentStyle}
                          onOpen={
                            (e) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }
                          }
                          trigger={open => (
                            <a href="#"
                                style={
                                  {
                                    "top": "-5px",
                                    "right": "15px",
                                    "position": "absolute"
                                  }
                                }
                                className="btn btn-link btn-sm text-muted">
                              <i className="far fa-ellipsis-v"></i>
                            </a>
                          )} >
                      {close => (
                        <div className='row text-left'>
                          <div className="col-12">
                            <ul className="list-group offer-inline-menu">
                              <li className="list-group-item" style={{"padding": "8px 10px"}}>
                                <a href="#"
                                  onClick={
                                    (e) => {
                                      e.preventDefault();
                                      close();
                                      fetchPrinters(venueOwnership);
                                      fetchVenueOwnership(csrfToken, team, venueOwnership.id);
                                    }
                                  }
                                  className="text-muted">
                                  <span className="d-inline-block text-center" style={{width: "28px"}}>
                                    <i className="fas fa-pencil"></i>
                                  </span>
                                  <span className="text-dark">
                                    Edit Venue Profile
                                  </span>
                                </a>
                              </li>
                              <li className="list-group-item" style={{"padding": "8px 10px"}}>
                                <a href="#"
                                  onClick={
                                    (e) => {
                                      e.preventDefault();
                                      close();
                                      fetchNewRoom(venueOwnership.id);
                                    }
                                  }
                                  className="text-muted">
                                  <span className="d-inline-block text-center" style={{width: "28px"}}>
                                    <i className="far fa-plus-circle"></i>
                                  </span>
                                  <span className="text-dark">
                                    Add a stage
                                  </span>
                                </a>
                              </li>
                              <li className="list-group-item" style={{"padding": "8px 10px"}}>
                                <Popup
                                    trigger={
                                      <a href="#" className="text-muted">
                                        <span className="d-inline-block text-center" style={{width: "28px"}}>
                                          <i className="fas fa-trash-alt"></i>
                                        </span>
                                        Remove
                                      </a>
                                    }
                                    modal
                                    onOpen={
                                      (e) => {
                                        e.preventDefault();
                                      }
                                    }
                                    contentStyle={deleteModalContentStyle}
                                    closeOnDocumentClick
                                  >
                                  {closeDeletePopup => (
                                    <div>
                                      <div className="row">
                                        <div className="col">
                                          <div className="row">
                                            <div className="col">
                                              <h5 style={{"marginBottom": "16px"}}>
                                                <strong>Delete venue?</strong>
                                              </h5>
                                            </div>
                                            <div className="col-xs-auto">
                                              <a href="#"
                                                className="text-dark"
                                                style={{"paddingRight": "15px"}}
                                                onClick={(e) => {e.preventDefault(); close();}} >
                                                <i className="fa fa-times"></i>
                                              </a>
                                            </div>
                                          </div>
                                          <p>{"Remove " + venueOwnership.venueable.name + " from your Opendate account?"}</p>
                                          <div className="text-right">
                                            <a href="#"
                                              onClick={
                                                (e) => {
                                                  e.preventDefault();
                                                  close();
                                                }
                                              }>
                                              Cancel
                                            </a>
                                            <a href="#"
                                              className="btn btn-danger ml-3"
                                              onClick={
                                                (e) => {
                                                  e.preventDefault();
                                                  close();
                                                  closeDeletePopup();
                                                  deleteVenueOwnership(csrfToken, team, venueOwnership);
                                                }
                                              }>
                                              Remove
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Popup>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                    </Popup>
                  </div>
                </div>
                <p className="mb-0">
                  {venueOwnership.venueable.address1}
                </p>
                {(venueOwnership.venueable.address2 && venueOwnership.venueable.address2.length > 0) ? (
                  <p className="mb-0">
                    <span>{venueOwnership.venueable.address2}</span>
                  </p>
                ) : null}
                <p className="mb-0">
                  {venueOwnership.venueable.city}, {venueOwnership.venueable.state_code} {venueOwnership.venueable.zip}
                </p>
                {payoutSetupEnabled && venueOwnership.needs_payout_bank_account && venueOwnership.collects_payouts ? (
                  <PayoutBankAccountBadge onSetUp={() => payoutSetupOpened(venueOwnership.id)} />
                ) : null}
              </div>
              {venueOwnership.rooms && venueOwnership.rooms.length > 1 ? (
                <div className="card-body"
                      style={{
                        "borderTop": "1px solid #E9EAEB",
                        "padding": "6px 16px 16px 16px"
                      }}>
                  <div className="row">
                    <div className="col-12">
                      <p className="text-muted"
                          style={{
                            "fontSize": "12px",
                            "marginBottom": "1px"
                          }}>
                        Stages ({venueOwnership.rooms.length})
                      </p>
                                             <div className="d-flex flex-wrap">
                         {venueOwnership.rooms.sort((a, b) => a.name.localeCompare(b.name)).map((roomItem, roomIndex) => (
                           <span key={roomIndex}
                                 onClick={() => fetchEditRoom(roomItem.id)}
                                className="badge badge-light"
                                style={{
                                  "marginRight": "8px",
                                  "marginBottom": "5px",
                                  "cursor": "pointer",
                                  "padding": "2px 6px",
                                  "fontSize": "12px",
                                  "borderRadius": "6px",
                                  "background": "#FAFAFA",
                                  "border": "1px solid #E9EAEB",
                                  "fontWeight": "normal"
                                }}>
                                                         {roomItem.name} <i className="fas fa-arrow-right" style={{ "fontSize": "10px", "marginLeft": "2px" }}></i>
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {venueOwnership.isEditing ? (
                <div className="row pt-4">
                  <div className="col-12 col-lg-10">
                    <form
                      className="card-body"
                      onSubmit={e => {
                        e.preventDefault();

                        if(!canSubmitVenueOwnershipForm(venueOwnership)){
                          return false;
                        }

                        updateVenueOwnership(csrfToken, team, venueOwnership);
                      }}
                    >
                      <div className="form-row">
                        <div className='col-12 col-sm-6'>
                          <div className="form-group">
                            <label htmlFor={"venue-time-zone-" + index}>
                              <strong>Venue Timezone</strong>
                            </label>
                            <select className="custom-select form-control"
                                    id={"venue-time-zone-" + index}
                                    value={venueOwnership.time_zone || ""}
                                    onChange={
                                      (e) => {
                                        var updated = Object.assign({}, venueOwnership, {
                                          time_zone: e.target.value
                                        });

                                        venueOwnershipChanged(updated);
                                      }
                                    }
                                    style={{
                                      "fontSize": "14px",
                                      "border": "1px solid #e7e7e7"
                                    }}>
                              { availableTimezones.map(timezone => (
                                <option value={timezone} key={timezone}>{timezone}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className='col-12 col-sm-6'>
                          <div className="form-group">
                            <label htmlFor={"venue-phone-" + index}>
                              <strong>Venue Phone Number</strong>
                            </label>
                            <MaskedInput className="form-control"
                                         id={"venue-phone-" + index}
                                         placeholder="(317) 867-5309"
                                         style={{"border": "1px solid #e6e6e6", "fontSize": "14px"}}
                                         guide={false}
                                         onChange={
                                           (e) => {
                                             var updated = Object.assign({}, venueOwnership, {
                                               phone: e.target.value
                                             });

                                             venueOwnershipChanged(updated);
                                           }
                                         }
                                         value={venueOwnership.phone || ""}
                                         mask={['(',/[1-9]/,/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/]} />
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className='col-12 col-sm-6'>
                          <div className="form-group">
                            <label htmlFor={"venue-email-" + index}>
                              <strong>Venue Email</strong>
                            </label>
                            <input type="email"
                                   className="form-control"
                                   placeholder="support@venue.com"
                                   id={"venue-email-" + index}
                                   style={{"border": "1px solid #e6e6e6", "fontSize": "14px"}}
                                   onChange={
                                     (e) => {
                                       var updated = Object.assign({}, venueOwnership, {
                                         email: e.target.value
                                       });

                                       venueOwnershipChanged(updated);
                                     }
                                   }
                                   value={venueOwnership.email || ""} />
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className='col-12 col-lg-6'>
                          <label htmlFor={"venue-bio-" + index}>
                            <strong>Venue Logo</strong>
                          </label>
                          <div className="row">
                            <div className="col-xs-auto" style={{"paddingLeft": "15px"}}>
                              <input
                                ref={el => {
                                  if(el && !venueOwnership.logoEl){
                                    venueOwnershipLogoElChanged(index, el);
                                  }
                                }}
                                onChange={
                                  (e) => {
                                    var file = e.target.files[0];
                                    venueOwnershipLogoChanged(index, file);

                                    e.target.value = null;
                                  }
                                }
                                accept="image/*"
                                type="file"
                                style={{ display: "none" }} />
                              <div style={
                                     {
                                       "width": "80px",
                                       "height": "80px",
                                       "overflow": "hidden"
                                     }
                                   }
                                   className="rounded-circle ml-1">
                                <img src={
                                       venueOwnership.logo ? (
                                         URL.createObjectURL(venueOwnership.logo)
                                       ) : venueOwnership.logo_thumb_url ? (
                                         venueOwnership.logo_thumb_url
                                       ) : (
                                         "/venue-logoplaceholder.png"
                                       )
                                     }
                                     style={{"height": "100%"}}
                                     className="img-fluid" />
                              </div>
                            </div>
                            <div className="col">
                              <p className="mb-0 text-muted small">
                                Images must be at least 200 x 200px
                              </p>
                              <a href="#"
                                 style={{"borderRadius": "8px"}}
                                 onClick={
                                   (e) => {
                                     e.preventDefault();
                                     venueOwnership.logoEl.click();
                                   }
                                 }
                                 className="btn btn-primary btn-sm mt-2">
                                Choose Photo
                              </a>
                              {(venueOwnership.logo || venueOwnership.logo_thumb_url) ? (
                                <p className="mb-0 pt-2">
                                  <a href="#"
                                     onClick={
                                       (e) => {
                                         e.preventDefault();
                                         venueOwnershipLogoRemoved(index);
                                       }
                                     }
                                     className="text-red mt-2 small">
                                    Remove
                                  </a>
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-row">
                        <div className='mt-4 col-12 col-lg-6'>
                          <label htmlFor={"venue-bio-" + index}>
                            <strong>Ticket Logo</strong>
                          </label>
                          <div className="row">
                            <div className="col-xs-auto" style={{"paddingLeft": "15px"}}>
                              <input
                                ref={el => {
                                  if(el && !venueOwnership.ticketLogoEl){
                                    venueOwnershipTicketLogoElChanged(index, el);
                                  }
                                }}
                                onChange={
                                  (e) => {
                                    var file = e.target.files[0];
                                    venueOwnershipTicketLogoChanged(index, file);

                                    e.target.value = null;
                                  }
                                }
                                accept="image/*"
                                type="file"
                                style={{ display: "none" }} />
                              <div style={
                                     {
                                       "width": "80px",
                                       "height": "80px",
                                       "overflow": "hidden"
                                     }
                                   }
                                   className="rounded-circle ml-1">
                                <img src={
                                       venueOwnership.ticketLogo ? (
                                         URL.createObjectURL(venueOwnership.ticketLogo)
                                       ) : venueOwnership.ticket_logo_thumb_url ? (
                                         venueOwnership.ticket_logo_thumb_url
                                       ) : (
                                         "/venue-logoplaceholder.png"
                                       )
                                     }
                                     style={{"height": "100%"}}
                                     className="img-fluid" />
                              </div>
                            </div>
                            <div className="col">
                              <p className="mb-0 text-muted small">
                                Will be displayed in black and white, at 100x100 pixels
                              </p>
                              <a href="#"
                                 style={{"borderRadius": "8px"}}
                                 onClick={
                                   (e) => {
                                     e.preventDefault();
                                     venueOwnership.ticketLogoEl.click();
                                   }
                                 }
                                 className="btn btn-primary btn-sm mt-2">
                                Choose Photo
                              </a>
                              {(venueOwnership.ticket_logo || venueOwnership.ticket_logo_thumb_url) ? (
                                <p className="mb-0 pt-2">
                                  <a href="#"
                                     onClick={
                                       (e) => {
                                         e.preventDefault();
                                         venueOwnershipTicketLogoRemoved(index);
                                       }
                                     }
                                     className="text-red mt-2 small">
                                    Remove
                                  </a>
                                </p>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-row mt-3">
                        <div className='col-12'>
                          <label className="w-100"
                                 htmlFor={"venue-bio-" + index}>
                            <div className="form-row">
                              <div className="col">
                                <strong>Venue Bio</strong>
                              </div>
                              <div className="col-xs-auto">
                                <a href="https://www.markdownguide.org/cheat-sheet/" target="_blank">
                                  Formatting Help
                                </a>
                              </div>
                            </div>
                          </label>
                          <MdEditor style={{
                                      height: '300px'
                                    }}
                                    view={{menu: true, md: true, html: false}}
                                    id={"venue-bio-" + index}
                                    plugins={
                                      [
                                        'header',
                                        'font-bold',
                                        'font-italic',
                                        'font-underline',
                                        'font-strikethrough',
                                        'list-unordered',
                                        'list-ordered',
                                        'block-quote',
                                        'block-wrap',
                                        'table',
                                        'image',
                                        'link',
                                        'clear',
                                        'logger',
                                        'mode-toggle',
                                        'full-screen',
                                        'tab-insert'
                                      ]
                                    }
                                    onImageUpload={
                                      (file, callback) => {
                                        uploadImageEmbed(csrfToken, team, file, callback);
                                      }
                                    }
                                    renderHTML={
                                      (text) => mdParser.render(text)
                                    }
                                    value={venueOwnership.bio || ""}
                                    onChange={
                                      ({text}) => {
                                        venueOwnershipBioChanged(index, text);
                                      }
                                    } />
                        </div>
                      </div>
                      {user.admin === true ? (
                        <div className="form-row mt-3">
                          <div className='col-12'>
                            <label className="w-100" htmlFor={"venue-printers-" + index}>
                              <div className="form-row">
                                <div className="col">
                                  <strong>Printers</strong>
                                </div>
                              </div>
                            </label>
                            <div>
                              {printers.length > 0 ? (
                                <div className="mb-3">
                                  {printers
                                    .sort((a, b) => {
                                      const aNum = parseInt(a.name.match(/printer-(\d+)/)?.[1] || 0);
                                      const bNum = parseInt(b.name.match(/printer-(\d+)/)?.[1] || 0);
                                      return aNum - bNum;
                                    })
                                    .map((printer, printerIndex) => {
                                    const ipAddress = printer.options["device-uri"].replace("socket://", "");
                                    const isSelfService = printer.options["printer-info"] === "Self-Service";
                                    const printerNumber = printer.name.match(/printer-(\d+)/)?.[1] || (printerIndex + 1);
                                    const displayValue = isSelfService
                                      ? ipAddress
                                      : 'xxx.xxx.xxx.xxx';
                                    return(
                                      <div key={printer.id || printerIndex} className="d-flex align-items-center mb-2">
                                        <label className="mb-0 mr-3" style={{"fontSize": "14px", "minWidth": "100px"}}>
                                          Printer {printerNumber}
                                        </label>
                                        <div className="mr-3" style={{"width": "150px"}}>
                                          <input
                                            type="text"
                                            readOnly
                                            className="form-control"
                                            style={{"border": "1px solid #e6e6e6", "fontSize": "14px"}}
                                            value={displayValue}
                                          />
                                        </div>
                                        <div>
                                          <div className="d-flex align-items-center">
                                            <i className="fas fa-check-circle text-success"
                                               style={{"fontSize": "16px"}}
                                               title="Connected"></i>
                                            {!isSelfService && (
                                              <span className="ml-2 text-muted" style={{"fontSize": "10px", "fontVariant": "small-caps"}}>
                                                VPN
                                              </span>
                                            )}
                                            {isSelfService && (
                                              <i className="fas fa-times-circle text-danger ml-2"
                                                 style={{"fontSize": "16px", "cursor": "pointer"}}
                                                 title="Delete printer"
                                                 onClick={() => deletePrinter(printer, printerIndex)}></i>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              ) : (
                                <p className="text-muted mb-3" style={{"fontSize": "14px"}}>
                                  No printers configured
                                </p>
                              )}
                              <h6 className="mb-2" style={{"fontSize": "14px", "fontWeight": "600"}}>
                                Add Printer
                              </h6>
                              <div className="d-flex align-items-center mb-2">
                                <label className="mb-0 mr-3" style={{"fontSize": "14px", "minWidth": "100px"}}>
                                  IP Address
                                </label>
                                <div className="mr-3" style={{"width": "150px"}}>
                                  <input
                                    type="text"
                                    name="printerUri"
                                    ref={printerUri}
                                    className="form-control"
                                    placeholder="Ex: 192.168.1.100"
                                    style={{"border": "1px solid #e6e6e6", "fontSize": "14px"}}
                                  />
                                </div>
                                <div>
                                  <button
                                    type="submit"
                                    className="btn btn-primary btn-sm"
                                    style={{"fontSize": "12px"}}
                                    onClick={e => {
                                      e.preventDefault();
                                      addPrinter(printerUri.current.value);
                                      printerUri.current.value = "";
                                    }}
                                  >
                                    Add
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="form-row mt-4">
                        <div className="col-12">
                          <label>
                            <strong>Simplified Support Settlement</strong>
                          </label>
                          <p className="text-muted small mb-3">
                            Control whether a show summary appears for support act settlements
                          </p>
                          <div className="custom-control custom-switch mt-2">
                            <input
                              type="checkbox"
                              id={"venue-simplified-support-settlement-" + index}
                              className="custom-control-input"
                              checked={venueOwnership.simplified_support_settlement || false}
                              onChange={e => {
                                var updated = Object.assign({}, venueOwnership, {
                                  simplified_support_settlement: e.target.checked
                                });
                                venueOwnershipChanged(updated);
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"venue-simplified-support-settlement-" + index}
                              style={{
                                fontSize: "14px",
                                paddingTop: "2px"
                              }}
                            >
                              Simplified support settlement
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-row mt-4">
                        <div className="col-12">
                          <label>
                            <strong>Signature Lines</strong>
                          </label>
                          <p className="text-muted small mb-3">
                            Control whether signature lines appear at the bottom of offers and settlements for this venue.
                          </p>
                          <div className="custom-control custom-switch mt-2">
                            <input
                              type="checkbox"
                              id={"venue-show-signature-lines-on-offer-" + index}
                              className="custom-control-input"
                              checked={venueOwnership.show_signature_lines_on_offer || false}
                              onChange={e => {
                                var updated = Object.assign({}, venueOwnership, {
                                  show_signature_lines_on_offer: e.target.checked
                                });
                                venueOwnershipChanged(updated);
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"venue-show-signature-lines-on-offer-" + index}
                              style={{
                                fontSize: "14px",
                                paddingTop: "2px"
                              }}
                            >
                              Show signature lines on offers
                            </label>
                          </div>
                          <div className="custom-control custom-switch mt-2">
                            <input
                              type="checkbox"
                              id={"venue-show-signature-lines-on-settlement-" + index}
                              className="custom-control-input"
                              checked={venueOwnership.show_signature_lines_on_settlement || false}
                              onChange={e => {
                                var updated = Object.assign({}, venueOwnership, {
                                  show_signature_lines_on_settlement: e.target.checked
                                });
                                venueOwnershipChanged(updated);
                              }}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={"venue-show-signature-lines-on-settlement-" + index}
                              style={{
                                fontSize: "14px",
                                paddingTop: "2px"
                              }}
                            >
                              Show signature lines on settlements
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-row mt-4">
                        <div className="col-12 col-md-4">
                          <label htmlFor={"venue-default-facility-fee-" + index}>
                            <strong>Default Facility Fee</strong>
                          </label>
                          <p className="text-muted small mb-2">
                            Per-ticket facility fee that auto-populates on new offers for this venue.
                          </p>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">$</span>
                            </div>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              id={"venue-default-facility-fee-" + index}
                              className="form-control"
                              value={venueOwnership.default_facility_fee || ''}
                              placeholder="0.00"
                              onChange={e => {
                                var updated = Object.assign({}, venueOwnership, {
                                  default_facility_fee: e.target.value
                                });
                                venueOwnershipChanged(updated);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {venueOwnership.errors && venueOwnership.errors.length > 0 ? (
                        <div className="form-group pt-3">
                          <div className="p-3 bg-danger text-white rounded">
                            <ul className="mb-0">
                              {venueOwnership.errors.map((error, key) =>
                                <li key={key}>{error}</li>
                              )}
                            </ul>
                          </div>
                        </div>
                      ) : null}
                      <div className="form-row pt-3">
                        <div className="col-12 text-right">
                          <a onClick={
                               (e) => {
                                 e.preventDefault();
                                 setPrinters([]);
                                 cancelEditVenueOwnership();
                               }
                             }
                             href="#">
                            Cancel
                          </a>
                          <button type="submit"
                                  disabled={!canSubmitVenueOwnershipForm(venueOwnership)}
                                  className="btn btn-primary ml-3">
                            Save
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ))}
      </div>
      <div className="row"
           style={{
             "paddingTop": (
               venueOwnerships.length > 0 ? (
                 "25px"
               ) : venueSuggestionFormOpen ? (
                 "0px"
               ) : (
                 "130px"
               )
             )
           }}>
        <div className="col">
          <p className="text-muted small">
            *Manually entered venues will be reviewed by the Opendate team. You'll receive a notification when your venue is available in the app.
          </p>
        </div>
        {settingUpTeam ? (
          <div className="col-xs-auto text-right">
            <form action={"/teams/" + team.id + "/setup"}
                  onSubmit={
                    (e) => {
                      if(venueOwnerships.length === 0){
                        e.preventDefault();
                      }
                    }
                  }
                  method="post">
              <input type="hidden" name="_method" value="patch" autoComplete="off" />
              <input type="hidden" name="authenticity_token" value={csrfToken} autoComplete="off" />
              <input type="submit"
                     value="Finish"
                     style={{'fontWeight': 'bold'}}
                     className={"btn btn-primary " + (venueOwnerships.length === 0 ? "disabled" : "")} />
            </form>
          </div>
        ) : null}
      </div>
    </div>
    <Popup
      open={modalIsOpen}
      contentStyle={modalContentStyle}
      closeOnDocumentClick
      onClose={() => closeModal()}
    >
      <div>
        <a href="#"
           className="text-dark"
           style={
             {
               "position": "absolute",
               "right": "15px",
               "top": "15px"
             }
           }
           onClick={(e) => {e.preventDefault(); closeModal();}} >
          <i className="fa fa-times"></i>
        </a>
        <div className="text-center">
          <h2 style={{"color": "#ed6464"}}>
            <strong>Thank you!</strong>
          </h2>
          <p>Your venue submission is being reviewed by the Opendate team. We'll let you know when the venue is available in the app.</p>
        </div>
      </div>
    </Popup>
    {payoutSetupVenueOwnership ? (
      <PayoutSetupModal
        key={payoutSetupVenueOwnership.id}
        venueOwnership={payoutSetupVenueOwnership}
        payoutSetup={payoutSetup}
        onSave={(venueOwnership, venueBankLink) => assignPayoutBankAccount(csrfToken, team, venueOwnership, venueBankLink)}
        onClose={() => payoutSetupClosed()}
      />
    ) : null}
    {room && (
      <SlidingPane
        isOpen={true}
        className="sliding-pane-container"
        width={"400px"}
        hideHeader={true}
        onRequestClose={() => setRoom(null)}
      >
        <div className="row">
          <div className="col-12">
            <div className="row mx-0"
                 style={{"borderBottom": "2px solid #f5f5f5"}}>
              <div className="col" style={{"padding": "20px 24px"}}>
                                 <strong style={{"fontSize": "18px"}}>
                   {room.isEditing ? "Edit Stage" : "Add Stage"}
                 </strong>
              </div>
              <div className="col-xs-auto d-flex align-items-center" style={{"paddingRight": "15px"}}>
                <a href="#"
                   style={{"fontSize": "24px"}}
                   className="text-dark"
                   onClick={(e) => {
                     e.preventDefault();
                     setRoom(null);
                   }} >
                  <i className="fal fa-times"></i>
                </a>
              </div>
            </div>
            <div className="row mx-0">
              <div className="col-12" style={{"padding": "16px"}}>
                                 <form onSubmit={
                    (e) => {
                      e.preventDefault();
                      
                      if(!canSubmitRoomForm()) {
                        return false;
                      }

                      if(room.isEditing) {
                        updateRoom(room);
                      } else {
                        createRoom(room);
                      }
                    }
                  }>
                  <div className="form-group">
                    <label htmlFor="stage-name" style={{"fontSize": "14px"}}>
                      Stage Name
                      <span style={{"color": "#1982C4"}}>*</span>
                    </label>
                                         <input type="text"
                            className="form-control"
                            id="stage-name"
                            placeholder="Enter stage name"
                            value={room.name || ""}
                            onChange={(e) => {
                              var updatedRoom = Object.assign({}, room, {
                                name: e.target.value
                              });
                              setRoom(updatedRoom);
                            }}
                           style={{"border": "1px solid #e6e6e6", "fontSize": "16px"}} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="stage-capacity" style={{"fontSize": "14px"}}>
                      Capacity
                      <span style={{"color": "#1982C4"}}>*</span>
                    </label>
                    <MaskedInput
                      className="form-control"
                      id="stage-capacity"
                      placeholder="Enter a capacity"
                      mask={capacityMask}
                      value={room.capacity || ""}
                      onChange={(e) => {
                        var updatedRoom = Object.assign({}, room, {
                          capacity: e.target.value.replace(/,/g, '')
                        });
                        setRoom(updatedRoom);
                      }}
                      style={{"border": "1px solid #e6e6e6", "fontSize": "16px"}} />
                  </div>
                  <div className="form-group">
                    <label htmlFor="stage-type" style={{"fontSize": "14px"}}>
                      Stage Type
                      <span style={{"color": "#1982C4"}}>*</span>
                    </label>
                    <select
                      className="form-control custom-select"
                      id="stage-type"
                      value={room.stage_type || ""}
                      onChange={(e) => {
                        var updatedRoom = Object.assign({}, room, {
                          stage_type: e.target.value
                        });
                        setRoom(updatedRoom);
                      }}
                      style={{"border": "1px solid #e6e6e6", "fontSize": "16px"}}>
                      <option value="">Select stage type</option>
                      {STAGE_TYPES.map((stageType, index) => (
                        <option value={stageType} key={index}>
                          {stageType}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="stage-notes" style={{"fontSize": "14px"}}>
                      Note
                    </label>
                    <textarea
                      className="form-control"
                      id="stage-notes"
                      placeholder="Add a note"
                      rows="3"
                      value={room.notes || ""}
                      onChange={(e) => {
                        var updatedRoom = Object.assign({}, room, {
                          notes: e.target.value
                        });
                        setRoom(updatedRoom);
                      }}
                      style={{"border": "1px solid #e6e6e6", "fontSize": "16px"}} />
                  </div>
                    <div className={"form-group d-flex align-items-center " + (room && room.id ? "justify-content-between" : "justify-content-end")}>
                     {room && room.id ? (
                       <a href="#"
                         onClick={(e) => {
                           e.preventDefault();
                           deleteRoom(room);
                         }}
                         style={{
                           "fontWeight": "600"
                         }}
                         className="text-danger">
                         <i className="fas fa-trash-alt" style={{ "marginRight": "5px" }}></i>
                         Remove Stage
                       </a>
                     ) : null}
                    <div>
                      <a href="#"
                           onClick={(e) => {
                             e.preventDefault();
                             setRoom(null);
                           }}
                         style={{
                          "marginRight": "10px",
                          "fontWeight": "600",
                          "border": "1px solid #D5D7DA"
                         }}
                         className="btn btn-outline-secondary">
                        Cancel
                      </a>
                                             <button type="submit"
                               disabled={!canSubmitRoomForm()}
                               style={{
                                 "fontWeight": "600"
                               }}
                               className="btn btn-primary">
                         {room.isEditing ? "Save" : "Create Stage"}
                       </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </SlidingPane>
    )}
  </div>
  );
};

VenueManager.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  venueOwnerships: PropTypes.array.isRequired,
  deleteVenueOwnership: PropTypes.func.isRequired,
  createVenueOwnership: PropTypes.func.isRequired,
  settingUpTeam: PropTypes.bool,
  venueSuggestionFormOpen: PropTypes.bool,
  manualVenueEntryClicked: PropTypes.func.isRequired,
  venueSuggestion: PropTypes.object,
  venueSuggestionNameChanged: PropTypes.func.isRequired,
  venueSuggestionAddressOneChanged: PropTypes.func.isRequired,
  venueSuggestionAddressTwoChanged: PropTypes.func.isRequired,
  venueSuggestionCityChanged: PropTypes.func.isRequired,
  venueSuggestionStateChanged: PropTypes.func.isRequired,
  venueSuggestionZipChanged: PropTypes.func.isRequired,
  venueStateOptions: PropTypes.array.isRequired,
  createVenueSuggestion: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
  cancelEditVenueOwnership: PropTypes.func.isRequired,
  venueOwnershipBioChanged: PropTypes.func.isRequired,
  venueOwnershipLogoElChanged: PropTypes.func.isRequired,
  venueOwnershipLogoChanged: PropTypes.func.isRequired,
  venueOwnershipTicketLogoElChanged: PropTypes.func.isRequired,
  venueOwnershipTicketLogoChanged: PropTypes.func.isRequired,
  fetchVenueOwnership: PropTypes.func.isRequired,
  venueOwnershipLogoRemoved: PropTypes.func.isRequired,
  venueOwnershipTicketLogoRemoved: PropTypes.func.isRequired,
  updateVenueOwnership: PropTypes.func.isRequired,
  venueOwnershipChanged: PropTypes.func.isRequired,
  availableTimezones: PropTypes.array.isRequired,
  payoutSetup: PropTypes.shape({
    enabled: PropTypes.bool,
    financeSettingsPath: PropTypes.string,
    verifiedBankLinks: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      mask: PropTypes.string
    }))
  }),
  payoutSetupVenueOwnershipId: PropTypes.number,
  payoutSetupOpened: PropTypes.func.isRequired,
  payoutSetupClosed: PropTypes.func.isRequired,
  assignPayoutBankAccount: PropTypes.func.isRequired
};

export default VenueManager;
